<div class="main-body">
    <p class="h1">Nutri<span style='color: #232323;'>Mind</span></p>
    <p class="description">{{ 'homePage.txtDescr' | translate }}</p>
    <div class="block-form-login d-flex justify-content-center flex-column">
        <div class="block-form-login__title">
            {{ 'homePage.txtEnter' | translate }}
        </div>
        <div class="block-form-login__description">
            {{ 'homePage.txtLogin' | translate }}
        </div>
        <div class="block-form-login__content">
            <app-login-component/>
            <section class="d-flex justify-content-center align-items-center line_span">
                <hr color="#D9D9D9" size="1"/>
                <span style="color: #6E6E6E;">{{ 'homePage.txtOr' | translate }}</span>
                <hr color="#D9D9D9" size="1"/>
            </section>
            <section class="container px-0 mt-24">
                <app-social-links/>
            </section>
            <section class="container px-0">
                <app-link-registration/>
            </section>
        </div>
    </div>
</div>
<div class="main-block-language">
    <app-select-language/>
</div>


